import React, { useEffect, useState } from 'react';
import './App.css';
import VideoPlayer from './components/VideoPlayer';
import AudioPlayer from './components/AudioPlayer';
import { isMobile } from './components/utils/is-mobile';
import 'video.js/dist/video-js.css';
function App() {
  let videoId = null;
  const search = document.location.search;

  try {
    const v = search.split('v=')[1].split("&")[0];
    videoId = v;
  } catch (e) {
  }

  let audioId = null;
  try {
    const a = search.split('a=')[1].split("&")[0];
    audioId = a;
  } catch (e) {
  }

  let autoPlay = false;
  try {
    const a = search.split('autoPlay=')[1].split("&")[0];
    autoPlay = a === 'true' || a === '1';
  } catch (e) {
  }

  let bgHex = "FFFFFF";
  try {
    const a = search.split('bgHex=')[1].split("&")[0];
    bgHex = a;
  } catch (e) {
  }

  // The account watching, when the embedding site names one: saved positions are then its own.
  let viewer = null;
  try {
    const a = search.split('viewer=')[1].split("&")[0];
    viewer = a || null;
  } catch (e) {
  }

  // Which brand to dress as (page title, default cover, seek-block message): `theme=essr|gsds`
  // wins; without it (or with an unrecognized value) it falls back to the domain, ESSR by default.
  let theme = null;
  try {
    const a = search.split('theme=')[1].split("&")[0].toLowerCase();
    theme = a === 'essr' || a === 'gsds' ? a : null;
  } catch (e) {
  }
  const isGsds = theme ? theme === 'gsds' : window.location.hostname === 'play.gsds.ch';

  let preventSeekForward = false;
  try {
    const a = search.split('preventSeekForward=')[1].split("&")[0];
    preventSeekForward = a === 'true' || a === '1';
  } catch (e) {
  }


  const [coverUrl, setCoverUrl] = useState(null);
  const [coverUrlSetupCompleted, setCoverUrlSetupCompleted] = useState(false);
  const [preventSeekForwardMessage, setPreventSeekForwardMessage] = useState("");

  // Check if URL exists by sending a HEAD request to it
  const checkUrl = async (url) => {
    try {
    const coverCheckResponse = await fetch(url, { method: 'HEAD' });
      if(coverCheckResponse.ok) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  // Check if cover exists
  useEffect (() => {
    const checkCoverUrl = async () => {
      if(videoId) {
        let cleanVideoId = videoId.split('video_')[1];
        cleanVideoId = cleanVideoId?.split('.')[0];

        const coverUrlPrefix = `https://essr-media.fra1.cdn.digitaloceanspaces.com/videos/`;
        const coverUrlSuffix = `/cover.png`;

        const defaultCoverId = isGsds
          ? '00000000-0000-0000-0000-000000000002'
          : '00000000-0000-0000-0000-000000000001';
        const coverCandidates = [];

        if(isMobile()) {
          coverCandidates.push(`${coverUrlPrefix}${cleanVideoId}/cover-mobile.png`);
        }

        coverCandidates.push(
          `${coverUrlPrefix}${cleanVideoId}${coverUrlSuffix}`,
          `${coverUrlPrefix}${defaultCoverId}${coverUrlSuffix}`
        );

        let coverUrl = null;
        for(const candidate of coverCandidates) {
          if(await checkUrl(candidate)) {
            coverUrl = candidate;
            break;
          }
        }

        setCoverUrl(coverUrl);
        setCoverUrlSetupCompleted(true);
      }
    }

    checkCoverUrl();
  }, [videoId, isGsds]);

  /**
   * Add custom message based in location
   * This is used to prevent seeking forward in the video
   */
  useEffect(() => {
    if(isGsds) setPreventSeekForwardMessage('Sie können dieses Video nicht vorspulen.');
    else setPreventSeekForwardMessage('Vous ne pouvez pas avancer cette vidéo.');

  }, [videoId, isGsds]);

  useEffect( () => {
    // Prevent select, copy, paste, right click ( only in prod )
    [ 'selectstart', 'cut', 'copy', 'paste', 'contextmenu'].forEach ( (event) => { 
      const fn = function(e) { e.preventDefault(); return false;  };
      document.querySelector('body').addEventListener(event, fn);
      document.addEventListener(event, fn);
    }
    )
  }, []);

  /**
   * Changes page title based on the theme (see `isGsds` above)
   */

  useEffect(() => {
    document.title = isGsds ? "Wiederholung der Sitzung" : "Revoir la session";
  }, [isGsds]);

  return videoId ? (
    coverUrlSetupCompleted ? (
      <div className="App">
        <VideoPlayer 
          videoId={videoId} 
          autoPlay={autoPlay} 
          bgHex={bgHex} 
          coverUrl={coverUrl} 
          preventSeekForward={preventSeekForward} 
          preventSeekForwardMessage={preventSeekForwardMessage} 
          viewer={viewer} 
        />
      </div>
    ) : null
  ) : audioId ? (
    <div className="App">
      <AudioPlayer audioId={audioId} autoPlay={autoPlay} />
    </div>
  ) : (
    'ESSR.CH'
  );
}

export default App;
